module.exports = __webpack_public_path__ + "img/search.d9887c21.svg";